import { NgModule } from '@angular/core';
import { CarouselListComponent } from './carousel-list.component';

@NgModule({
    declarations: [
        CarouselListComponent
    ],
    imports: [],
    exports: [
        CarouselListComponent
    ]
})
export class NcCarouselListModule { }